import React from 'react';
import AdminNavigation from '../../components/ui/AdminNavigation';
import Icon from '../../components/AppIcon';

const AdminCustomers = () => {
  return (
    <div className="min-h-screen bg-background">
      <AdminNavigation onToggleCollapse={() => {}} />
      
      <div className="lg:ml-64 min-h-screen">
        <div className="p-4 lg:p-8">
          <div className="max-w-7xl mx-auto">
            {/* Header */}
            <div className="mb-6">
              <h1 className="text-3xl font-heading font-bold text-foreground mb-2">
                Customer Management
              </h1>
              <p className="text-muted-foreground">
                Manage customer accounts, support, and relationships
              </p>
            </div>

            {/* Coming Soon Card */}
            <div className="bg-card rounded-xl border border-border p-8 text-center">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Users" size={32} className="text-primary" />
              </div>
              <h2 className="text-2xl font-heading font-semibold text-foreground mb-2">
                Customers Module Coming Soon
              </h2>
              <p className="text-muted-foreground max-w-md mx-auto">
                The customer management interface is under development. You'll be able to view customer profiles, manage support tickets, and analyze customer behavior here.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminCustomers;